import styled from "styled-components";

export const ComponentBaseContainer = styled.div`
  height: 90vh;
  display: flex;
  color: white;
  align-items: center;
  margin: 10px;
  padding: 10px;
`;

export const WordSummaryContainer = styled.div`
  width: 50%;
  margin: 10px;
  background: white;
  display: flex;
  flex-direction:column;
  box-shadow: 0 8px 24px rgba(255, 255, 255, 0.05),
              0 2px 6px rgba(0, 0, 0, 0.2);
`;

export const WordHeaderContainer = styled.div`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    margin: 10px;
    width: 50%;
    color: black;
      font-size: 20px;
  color: #333;
  box-shadow: 0 8px 24px rgba(255, 255, 255, 0.05),
              0 2px 6px rgba(0, 0, 0, 0.2);
`;